import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalizationService } from 'i2g-ng-utils';

@Pipe({
  name: 'percentage',
})
export class PercentagePipe implements PipeTransform {
  constructor(private _localizationService: LocalizationService) {}

  transform(
    value: any,
    locale = 'en-US',
    decimalDigits: number = 2
  ): string | Observable<string> {
    const decimalSeparator = this._localizationService.getDecimalSeparator(
      locale
    );
    const formatter = global.Intl.NumberFormat(
      this._localizationService.getFormattedLocale(locale),
      {
        style: 'percent',
        maximumFractionDigits: decimalDigits,
      }
    );
    const formattedPercentage = formatter.format(parseFloat(value) / 100 || 0);

    return formattedPercentage.toString().replace('.', decimalSeparator);
  }
}
